(function () {
  function storageKeyFor(root) {
    return 'promo-popup-dismissed-' + root.id;
  }

  function hasBeenDismissed(root, frequency) {
    if (frequency === 'every_page_load') return false;
    var key = storageKeyFor(root);
    try {
      if (frequency === 'once_per_session') {
        return sessionStorage.getItem(key) === 'true';
      }
      var match = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)'));
      return !!match;
    } catch (error) {
      return false;
    }
  }

  function remember(root, frequency) {
    var key = storageKeyFor(root);
    try {
      if (frequency === 'once_per_session') {
        sessionStorage.setItem(key, 'true');
        return;
      }
      if (frequency === 'once_per_day' || frequency === 'once_per_week') {
        var days = frequency === 'once_per_day' ? 1 : 7;
        var expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = key + '=true; expires=' + expires.toUTCString() + '; path=/';
      }
    } catch (error) {
      /* storage unavailable, fail silently */
    }
  }

  function initPromoPopup(root) {
    if (!root || root.dataset.promoPopupInit === 'true') return;
    root.dataset.promoPopupInit = 'true';

    var delay = parseInt(root.dataset.delay, 10);
    if (isNaN(delay)) delay = 4000;
    var frequency = root.dataset.frequency || 'once_per_session';
    var dialog = root.querySelector('.promo-popup__dialog');
    var overlay = root.querySelector('[data-promo-popup-overlay]');
    var closeBtn = root.querySelector('[data-promo-popup-close]');
    var copyBtn = root.querySelector('[data-promo-popup-copy]');
    var ctaBtn = root.querySelector('.promo-popup__button');
    var lastFocused = null;
    var timerId = null;

    function onKeydown(event) {
      if (event.key === 'Escape' || event.code === 'Escape') close(true);
    }

    function open() {
      lastFocused = document.activeElement;
      root.classList.add('promo-popup--visible');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', onKeydown);
      if (typeof trapFocus === 'function' && dialog) {
        trapFocus(dialog, closeBtn || dialog);
      } else if (closeBtn) {
        closeBtn.focus();
      }
    }

    function close(shouldRemember) {
      root.classList.remove('promo-popup--visible');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', onKeydown);
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(lastFocused);
      } else if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
      if (shouldRemember) remember(root, frequency);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(true);
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        close(true);
      });
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        remember(root, frequency);
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code') || '';
        var originalLabel = copyBtn.textContent;

        function showCopied() {
          copyBtn.textContent = copyBtn.getAttribute('data-copied-label') || 'Copied!';
          copyBtn.classList.add('promo-popup__copy--copied');
          window.setTimeout(function () {
            copyBtn.textContent = originalLabel;
            copyBtn.classList.remove('promo-popup__copy--copied');
          }, 2000);
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(showCopied).catch(function () {});
        } else {
          var textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          try {
            document.execCommand('copy');
            showCopied();
          } catch (error) {
            /* copy unsupported, ignore */
          }
          document.body.removeChild(textarea);
        }
      });
    }

    // typeof guard: a bare `Shopify` reference throws a ReferenceError if the
    // global is missing, which would kill the popup before the timer is set.
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      // Let merchants preview it instantly in the theme editor instead of waiting on the delay.
      root.addEventListener('shopify:section:select', function () {
        window.clearTimeout(timerId);
        open();
      });
      root.addEventListener('shopify:section:deselect', function () {
        close(false);
      });
      return;
    }

    if (!hasBeenDismissed(root, frequency)) {
      timerId = window.setTimeout(open, delay);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.promo-popup').forEach(initPromoPopup);
  });
})();
